import { useEffect, useMemo, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { getSites } from "@/api";
import { useAudienceContext } from "@/context";
import { Site } from "@/types";

export const useSites = () => {
  const { getAccessTokenSilently } = useAuth0();

  const [sites, setSites] = useState<Site[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);

  // const client = process.env.REACT_APP_CLIENT || 'core';
  const client = 'imedia';

  useEffect(() => {
    const fetchSites = async () => {
      setLoading(true);
      setError(null);

      try {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await getSites(accessToken, client);

        if (error) setError(true);

        setSites(data);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchSites();
  }, [getAccessTokenSilently]);

  return {
    sites,
    loading,
    error,
  };
};


export const useSelectedSites = (sites: Site[]) => {
  const { state } = useAudienceContext();

  const siteMap = useMemo(() => {
    return new Map((sites || []).map((s) => [s.site_id, s]));
  }, [sites]);

  // Extract the site ids
  const site_ids = state.currentAudience?.audience_type === 'site'
    ? state.currentAudience.site_config.sites
    : undefined;
  const site_ids_key =(site_ids || []).join(',');

  return useMemo(() => {
    if (!site_ids_key || siteMap.size === 0) return [];

    return site_ids_key.split(',').map(Number)
      .map((id) => siteMap.get(id))
      .filter((site): site is Site => Boolean(site));
  }, [site_ids_key, siteMap]);

}

